import { h } from 'preact';

const End = ({ restart, modifiers, result}) => {
    return (
        <div>
            <h3 className="text-center">{ result.label }</h3>
            <p className="text-center">{ result.description }</p>
            {
                modifiers.includes('DEMINIMIS') &&
                <small>Note: Highlight de minimis in landing pad notes.</small>
            }
            <div className="d-flex justify-content-center">
                <button type="button" className="btn btn-primary" onClick={() => restart(true)}>Start again</button>
            </div>
        </div>
    );
}

export default End;
